import { PageHeader } from "../../components";
import { FacilityPage } from "./facility";
import { BranchesPage } from "./branches";
import { ServicesPage } from "./services";
import { Tabs } from "antd";
import { CataloguePage } from "./catalogue";
import { CareFeeWalletPage } from "./care-fee-wallet";

const FacilityAdminPage = (props) => {
  const { TabPane } = Tabs;

  return (
    <section>
      <PageHeader title="Administration" hasBackButton />
      <Tabs defaultActiveKey="1" type="card">
        <TabPane
          tab={
            <span>
              <i className="bi bi-command me-2" /> General
            </span>
          }
          key="1">
          <FacilityPage />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="bi bi-building me-2" /> Branches
            </span>
          }
          key="2">
          <BranchesPage />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="bi bi-award me-2" /> Services
            </span>
          }
          key="3">
          <ServicesPage />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="bi bi-list-stars me-2" /> Catalogue
            </span>
          }
          key="4">
          <CataloguePage />
        </TabPane>
        <TabPane
          tab={
            <span>
              <i className="bi bi-wallet2 me-2" /> Care fee wallet
            </span>
          }
          key="5">
          <CareFeeWalletPage />
        </TabPane>
      </Tabs>
    </section>
  );
};

export { FacilityAdminPage };
